import React from 'react';

import googleDownload from '../screen/landingPage/assets/google-download.png';
import iosDownload from '../screen/landingPage/assets/ios-download.png';
import qrCode from '../screen/landingPage/assets/qr_code.avif';

const ANDROID_URL =
  'https://play.google.com/store/apps/details?id=br.com.multiplan.mind.multishopping&hl=pt_BR&gl=US&pli=1';
const IOS_URL = 'https://apps.apple.com/br/app/multi-promo%C3%A7%C3%B5es-dos-shoppings/id1459566420';

const DownloadCTA = ({ className = '' }) => (
  <div className={className}>
    {/* Mobile button */}
    <a
      href={'https://link.meumulti.com.br/jivm/3x40umvm'}
      target="_blank"
      rel="noopener noreferrer"
      className="md:hidden block bg-[#014B35] text-white rounded-full px-8 py-4 text-sm font-semibold text-center w-fit mx-auto"
    >
      Baixar o App
    </a>

    {/* Desktop layout */}
    <div className="hidden md:flex items-end gap-6">
      <div className="flex flex-col items-center gap-3">
        <span className="text-base font-semibold text-[#003424] text-center">Baixe o Multi</span>
        <img src={qrCode} alt="QR Code" className="bg-white p-1 rounded-lg" width={100} height={100} />
      </div>
      <div className="flex flex-col gap-4">
        <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer">
          <img src={googleDownload} alt="Google Play" className="cursor-pointer" width={121} height={41} />
        </a>
        <a href={IOS_URL} target="_blank" rel="noopener noreferrer">
          <img src={iosDownload} alt="App Store" className="cursor-pointer" width={121} height={41} />
        </a>
      </div>
    </div>
  </div>
);

export default DownloadCTA;
